module.exports = __webpack_public_path__ + "static/media/Avatars_Female-22.f013ac01.png";